skrilla.directive('queryUsers', function () {
    return {
        templateUrl: 'directives/queryUsers/queryUsers.html',
        scope: {
            users: "=",
            key: "=",
            reset: "=",
            simpleView: "="
        },
        controller: function ($scope,
                              searchService,
                              queryService,
                              paginationService,
                              cacheService,
                              countryService,
                              dateService,
                              currencyService,
                              profileTagService,
                              constantsService,
                              validationService) {
            $scope.currencies = currencyService.getCurrencies();
            $scope.states = constantsService.getAustralianStates();
            $scope.verificationStatuses = constantsService.getVerificationStatuses();

            $scope.marketingCategories = constantsService.getMarketingCategories();
            $scope.tags = profileTagService.getTagsForDropdown();
            $scope.validate = {}

            countryService.getQueryableCountries().then(function(countries){$scope.countries = countries;});
            $scope.view = {};
            if($scope.simpleView === undefined){
                $scope.view.showMore = true;
            }
            else {
                $scope.view.showMore = !$scope.simpleView;
            }
            $scope.resetBtn = function(){
                if($scope.reset === undefined) {
                    $scope.query = {
                        id: "",
                        username: "",
                        email: "",
                        firstName: "",
                        lastName: "",
                        phone: "",
                        cardBin: null,
                        cardFirstFourDigits: null,
                        cardLastFourDigits: null,
                        verificationStatus: null,
                        state: "",
                        country: null,
                        signupIp: "",
                        limit: 20,
                        calculateLifeTimeRevenue: false,
                        marketingCategories: constantsService.getMarketingCategoriesForQuery(),
                        statuses: {
                            ACTIVE: false,
                            LOCKED: false,
                            CLOSED: false
                        },
                        tags: profileTagService.getTagsForCheckboxes()
                    };
                    $scope.cardFirstFourOrSixDigits = null
                }
                else {
                    $scope.query = $scope.reset();
                }
            }
            $scope.query = cacheService.getObject("queryUsers" + $scope.key)
            if (!$scope.query) {
                $scope.resetBtn()
            }

            $scope.search = function () {
                if (validateForm()) {
                    paginationService.resetPage($scope.key);
                    paginationService.pageQuery(getUsers, $scope.key);
                }
            }

            var getUsers = function () {
                cacheService.registerObject("queryUsers" + $scope.key, $scope.query)
                setCardNumberQuery($scope.cardFirstFourOrSixDigits, $scope.query.cardLastFourDigits)
                const request = {...$scope.query,
                    dateOfBirth: dateService.compensateForTimezone($scope.query.dateOfBirth),
                };
                return searchService.getUsers(queryService.getQueryString(request, $scope.key), function (response) {
                    $scope.users = response.data.result;
                    cacheService.registerObject("usersTable" + $scope.key, $scope.users);
                    paginationService.setPage($scope.key, paginationService.buildPage(response));
                });
            }

            let setCardNumberQuery = function (numberFirst, numberLast) {
                $scope.query.cardBin = (numberFirst?.length === 6) ? numberFirst : null
                $scope.query.cardFirstFourDigits = (numberFirst?.length === 4) ? numberFirst : null
                $scope.query.cardLastFourDigits = numberLast || null
            }

            function validateForm() {
                let cardNumberFirst = $scope.cardFirstFourOrSixDigits
                let cardNumberLast = $scope.query.cardLastFourDigits
                let inputs = [
                    validationService.buildFieldValidationObj("cardNumberFirst", cardNumberFirst?.match('^[0-9]{4}$|^[0-9]{6}$')
                        || validationService.isEmpty(cardNumberFirst), "Must be blank or 4-6 digits."),
                    validationService.buildFieldValidationObj("cardNumberLast", cardNumberLast?.match('^[0-9]{4}$')
                        || validationService.isEmpty(cardNumberLast), "Must be blank or 4 digits."),
                ]
                return validationService.validateForm(inputs, $scope.validate)
            }

            $scope.btnPress = function (keyEvent) {
                if (keyEvent.which === 13)
                    $scope.search();
            }
        }
    };
});
